import type { ReactNode } from 'react';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import Header from './Header';
import Footer from './Footer';
import MobileNav from './MobileNav';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mobileOpened, { toggle, close }] = useDisclosure(false);

  return (
    <AppShell
      header={{ height: 70 }}
      navbar={{
        width: 300,
        breakpoint: 'md',
        collapsed: { desktop: true, mobile: !mobileOpened },
      }}
      padding={0}
    >
      <AppShell.Header>
        <Header mobileOpened={mobileOpened} onToggle={toggle} />
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <MobileNav onClose={close} />
      </AppShell.Navbar>

      <AppShell.Main>
        {children}
        <Footer />
      </AppShell.Main>
    </AppShell>
  );
}
